import { setFilter } from '../../../State/controls'

export default (key, value) => (dispatch) => {

  dispatch(setFilter({ key, value }))

}
